type Methods = "GET" | "POST" | "PUT" | "DELETE" | "PATCH";

/**
 * @returns request init object for fetch
 * 
 * @example
 * import { endpoints } from "../app/api/endpoints";
 * import CreateFetchInit from "../utils/create-fetch-init";
 * 
 * const token = await getToken();
 * 
 * const response = await fetch(
 *  endpoints.usersMe,
 *  CreateFetchInit("GET", undefined, token)
 * );
 */
export default (method: Methods, body?: any, token?: string): RequestInit => {
  const headers: HeadersInit = {
    "Content-Type": "application/json"
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return {
    method,
    headers,
    body: !body ? undefined : JSON.stringify(body)
  };
};
